import { ReactNode } from 'react';
import { cn } from 'utils/cn';

interface Props {
    children: ReactNode;
    className?: string;
}

// The page gutter inside the content area. Classic's is 12px on three sides, 24px from the full-HD
// breakpoint, none at the bottom; the new design's is the `--page-gutter-*` properties on all four sides.
// A caller's own bottom padding holds only in classic, below full HD.
function PaddedLayout({ children, className }: Props) {
    return (
        <div
            className={cn(
                'fullhd:p-6 fullhd:pb-0 new:px-(--page-gutter-x) new:py-(--page-gutter-y) p-3 pb-0',
                className
            )}
        >
            {children}
        </div>
    );
}

export default PaddedLayout;
